import { useLatest, usePrevious } from 'ahooks';
import { useState, useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import TabsController, { TTab } from './TabsController';

export default function useTabs() {
  const [tabs, setTabs] = useState<TTab[]>(TabsController.tabs);

  const previousTabs = usePrevious(tabs);
  const latestPrevious = useLatest(previousTabs);

  useEffect(() => {
    function handleTabsUpdate(newTabs: TTab[]) {
      if (!shallowEqual(newTabs, latestPrevious.current)) setTabs(newTabs);
    }
    TabsController.on('update', handleTabsUpdate);
    setTabs(TabsController.tabs);

    return () => {
      TabsController.off('update', handleTabsUpdate);
    };
  }, [latestPrevious]);

  return tabs;
}
